import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../user/UserSlice";
import { reload } from "../branchesSlice";
import Details from "./Details";
import Address from "./Address";
import StepsWizard from "../../../components/templates/StepsWizard";
import { createRecord } from "../../branchDetails/branchDetailsSlice";
import { isAllowedFeature } from "../../organization/organizationSlice";
var unflatten = require("flat").unflatten;

const NewbranchWizard = (props) => {
  const { hideWizard } = props;
  const dispatch = useDispatch();
  const [nextDisabled, setNextDisabled] = useState(true);
  const [values, setValues] = useState({});

  const createLoading = useSelector(
    (state) => state.pendingActions["employeeDetails/create"]
  );
  const required = ["name", "btl_accounting_number", "salary_id"];
  const validation = [
    "name",
    "btl_accounting_number",
    "salary_id",
    "phone_number",
    "email",
  ];

  if (isAllowedFeature("accounting_tag")) {
    required.push("accounting_number_tag");
    validation.push("accounting_number_tag");
  }
  if (process.env.REACT_APP_CONFIG === "matav") {
    required.push("group_id");
  }

  const steps = [
    {
      title: null,
      description: null,
      headline: <FormattedMessage id="app.branches.creationHeadline" />,
      subtitle: <FormattedMessage id="app.branches.personalSubtitle" />,
      required: required,
      validation: validation,
      comp: <Details values={values} />,
    },
    {
      title: null,
      description: null,
      subtitle: <FormattedMessage id="app.branches.addressSubtitle" />,
      required: ["address.city", "address.street", "address.house_number"],
      validation: ["address.city", "address.street", "address.house_number"],
      comp: <Address />,
    },
  ];

  const hide = () => {
    setNextDisabled(true);
    setValues({});
    hideWizard();
  };

  const setNext = (val) => {
    setNextDisabled(val);
  };

  const onFinish = async (formValues) => {
    const deepBranch = unflatten(formValues);
    const action = await dispatch(createRecord(deepBranch));
    if (!action.error) {
      hide();
      dispatch(fetchUserProfile());
      dispatch(reload());
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const changeValues = (val) => {
    setValues(val);
  };
  const onValuesChange = (changedValues, allValues) => {
    const newValues = unflatten(allValues);
    setValues({ ...values, ...newValues });
  };

  return (
    <StepsWizard
      formLayout={{
        labelCol: { span: 11 },
        wrapperCol: { span: 13 },
      }}
      steps={steps}
      setNext={setNext}
      changeValues={changeValues}
      values={values}
      onCancel={hide}
      onValuesChange={onValuesChange}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={hide}
      saveLoading={createLoading}
      createText={<FormattedMessage id="app.branches.createNewEmployee" />}
      nextDisabled={nextDisabled}
    />
  );
};

export default NewbranchWizard;
